import React from "react";
import { Outlet } from "react-router-dom";

const TeamIndex = () => {
    return <Outlet />;
};

export default TeamIndex;
